export default __webpack_public_path__ + "static/media/define-the-actions-for-an-entity.e1c686a7.svg";